/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRef } from "react";
import "./Sidebar.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { SkeletonSidebar } from "../../Components/Sections";

const Sidebar = ({ aboutLoading, sidebarData }) => {
  const Button = useRef(null);
  const Sidebar = useRef(null);

  const ShowProfile = () => {
    Sidebar.current.classList.toggle("active");
  };

  return (
    <>
      {/* #SIDEBAR */}
      <aside ref={Sidebar} className="sidebar" data-sidebar>
        {aboutLoading ? (
          <SkeletonSidebar />
        ) : (
          <>
            <div className="sidebar-info">
              <figure className="avatar-box">
                <LazyLoadImage
                  src={sidebarData.avatar}
                  alt={sidebarData.name}
                  width="80"
                />
              </figure>
              <div className="info-content">
                <h1 className="name" title={sidebarData.name}>
                  {sidebarData.name}
                </h1>
                <p className="title">{sidebarData.job_name}</p>
              </div>
              <button
                onClick={ShowProfile}
                ref={Button}
                className="info_more-btn"
                data-sidebar-btn
              >
                <span>Show Contacts</span>
                <ion-icon name="chevron-down"></ion-icon>
              </button>
            </div>
            <div className="sidebar-info_more">
              <div className="separator"></div>
              <ul className="contacts-list">
                <li className="contact-item">
                  <div className="icon-box">
                    <ion-icon name="mail-outline"></ion-icon>
                  </div>
                  <div className="contact-info">
                    <p className="contact-title">Email</p>
                    <a
                      href={"mailto:" + sidebarData.contacts.email}
                      className="contact-link"
                    >
                      {sidebarData.contacts.email}
                    </a>
                  </div>
                </li>
                <li className="contact-item">
                  <div className="icon-box">
                    <ion-icon name="phone-portrait-outline"></ion-icon>
                  </div>
                  <div className="contact-info">
                    <p className="contact-title">Phone</p>
                    <a
                      href={"tel:" + sidebarData.contacts.phone}
                      className="contact-link"
                    >
                      {sidebarData.contacts.phone}
                    </a>
                  </div>
                </li>
                <li className="contact-item">
                  <div className="icon-box">
                    <ion-icon name="calendar-outline"></ion-icon>
                  </div>
                  <div className="contact-info">
                    <p className="contact-title">Birthday</p>
                    <time dateTime="2005-09-11">{sidebarData.birthday}</time>
                  </div>
                </li>
                <li className="contact-item">
                  <div className="icon-box">
                    <ion-icon name="location-outline"></ion-icon>
                  </div>
                  <div className="contact-info">
                    <p className="contact-title">Location</p>
                    <address>{sidebarData.contacts.address}</address>
                  </div>
                </li>
              </ul>
              <div className="separator"></div>
              <ul className="social-list">
                {sidebarData.contacts.socials.map((social, idx) => (
                  <li className="social-item" key={idx}>
                    <a
                      href={social.url}
                      className="social-link"
                      title={social.name}
                    >
                      <ion-icon name={social.icon}></ion-icon>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </aside>
    </>
  );
};

export default Sidebar;
